/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

export const OVERLAY_HOST_ID = "ui-overlay-host";

/**
 * The one shared `.ui-root` host at the end of the body that every overlay (a modal, a dropdown
 * panel) renders into. Pages create stacking contexts and containing blocks (transforms,
 * z-indexed wrappers, the `.glass` backdrop filter) that would trap or shift an in-tree overlay;
 * a fixed-position overlay placed here is positioned against the viewport.
 */
export function overlayHost(): HTMLElement {
  const existing = document.getElementById(OVERLAY_HOST_ID);
  if (existing) return existing;
  const host = document.createElement("div");
  host.id = OVERLAY_HOST_ID;
  host.className = "ui-root";
  document.body.appendChild(host);
  return host;
}
